/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Target_Folder_ButtonInputs */

const en_drastic_tech_target_folder_button = /** @type {(inputs: Drastic_Tech_Target_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target Folder`)
};

const fr_drastic_tech_target_folder_button = /** @type {(inputs: Drastic_Tech_Target_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dossier cible`)
};

const de_drastic_tech_target_folder_button = /** @type {(inputs: Drastic_Tech_Target_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielordner`)
};

const it_drastic_tech_target_folder_button = /** @type {(inputs: Drastic_Tech_Target_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartella di destinazione`)
};

const ru_drastic_tech_target_folder_button = /** @type {(inputs: Drastic_Tech_Target_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целевая папка`)
};

const es_drastic_tech_target_folder_button = /** @type {(inputs: Drastic_Tech_Target_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpeta de destino`)
};

const zh_cn2_drastic_tech_target_folder_button = /** @type {(inputs: Drastic_Tech_Target_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标文件夹`)
};

const ja_drastic_tech_target_folder_button = /** @type {(inputs: Drastic_Tech_Target_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対象フォルダ`)
};

const hi_drastic_tech_target_folder_button = /** @type {(inputs: Drastic_Tech_Target_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लक्ष्य फ़ोल्डर`)
};

const pt_pt2_drastic_tech_target_folder_button = /** @type {(inputs: Drastic_Tech_Target_Folder_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasta de destino`)
};

/**
* | output |
* | --- |
* | "Target Folder" |
*
* @param {Drastic_Tech_Target_Folder_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_target_folder_button = /** @type {((inputs?: Drastic_Tech_Target_Folder_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Target_Folder_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_target_folder_button(inputs)
	if (locale === "de") return de_drastic_tech_target_folder_button(inputs)
	if (locale === "it") return it_drastic_tech_target_folder_button(inputs)
	if (locale === "ru") return ru_drastic_tech_target_folder_button(inputs)
	if (locale === "es") return es_drastic_tech_target_folder_button(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_target_folder_button(inputs)
	if (locale === "ja") return ja_drastic_tech_target_folder_button(inputs)
	if (locale === "hi") return hi_drastic_tech_target_folder_button(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_target_folder_button(inputs)
	return en_drastic_tech_target_folder_button(inputs)
});